<template>
  <div class="AI-draw-container" v-if="isOpen">
    <h3 class="title">AI绘画</h3>
    <div class="main-box">
      <div class="left-box">
        <div class="input-box">
          <textarea
            placeholder="请描述画面中的内容，描述的方式、顺序等都会对生成作品产生不同效果"
            v-model="inputText"
            maxlength="500"
            resize="none"
          />
          <div class="tips-box">
            <p>不知道如何输入画面描述？不妨点击下列词语试试</p>
            <div class="box-right">
              <p>{{ inputText.length }}/500</p>
              <div class="clear-btn" v-show="inputText.length" @click="clearInputText">
                <i class="el-icon-error"></i>
                清空
              </div>
            </div>
          </div>
          <div class="tips-text-list">
            <div class="list">
              <span
                class="tips-text"
                v-for="item in tipsTextList"
                :key="item.value"
                :class="{
                  select: inputText == item.value,
                }"
                @click="inputText = item.value"
                >{{ item.value }}</span
              >
            </div>
            <!-- <div class="action-btn">
              <i class="el-icon-refresh-right"></i>
              换一批
            </div> -->
          </div>
        </div>
        <div class="whmode-list">
          <div
            class="whmode-item"
            :class="{
              select: index == modeSelIndex,
            }"
            v-for="(item, index) in whModeList"
            :key="item.text"
            @click="modeSelIndex = index"
          >
            <img class="whmode-img" :src="item.styleImage" alt="" />
            <p class="whmode-text">{{ item.styleDesc }}</p>
            <p class="whmode-modename">{{ item.styleName }}</p>
          </div>
        </div>
      </div>
      <div class="img-box">
        <div class="big-image-box">
          <img v-show="selectImgUrl" id="bigImage" :src="selectImgUrl" alt="" />
          <div class="icon-box" v-show="selectImgUrl" @click="showPreviewImg = true">
            <i class="el-icon-full-screen"></i>
          </div>
        </div>
        <swiper :options="swiperOption" class="img-list">
          <swiper-slide alt="" v-for="(item, index) in imgList" :key="index">
            <div
              class="img-box"
              :class="{
                select: selectImgUrl == item.url,
              }"
            >
              <img @click="selectImgUrl = item.url" :src="item.url" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="action-box">
        <div class="btn-box" @click="addImg">
          <div class="icon-box">
            <i class="el-icon-document"></i>
          </div>
          <p>保存到图库</p>
        </div>
        <div class="btn-box" @click="downloadImage">
          <div class="icon-box">
            <i class="el-icon-download"></i>
          </div>
          <p>下载图片</p>
        </div>
      </div>
    </div>
    <button class="confirm-btn" @click="confrim" size="large" type="primary" round>
      立即生成
    </button>
    <div
      class="popup create"
      :class="{
        show: isCreate,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>AI图片生成</span>
        </div>
        <div class="popup-container">
          <div class="status-box">
            <i class="el-icon-loading" v-show="createStatus == 101"></i>
            <i
              class="el-icon-success"
              v-show="createStatus == 200 || createStatus == 300"
            ></i>
            <i class="el-icon-error" v-show="createStatus == 199"></i>
          </div>
          <el-button
            type="primary"
            size="small"
            v-show="createStatus == 200 || createStatus == 199 || createStatus == 300"
            @click="closeCreatePop"
            >确定</el-button
          >
          <el-button
            type="danger"
            size="large"
            v-show="createStatus == 101"
            @click="closeCreatePop"
            >停止生成</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="popup preview"
      :class="{
        show: showPreviewImg,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>图片预览</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="showPreviewImg = false"
          />
        </div>
        <div class="popup-container">
          <img class="preview-img" :src="selectImgUrl" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDrawStyleList,
  createAIDrawWork,
  singleDrawWork,
  addImg,
  findUserFuncInfo,
} from "@/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import html2canvas from "html2canvas";
let timer = null;
let timerNum = 0;

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      showPreviewImg: false,
      isCreate: false,
      createStatus: 101,
      inputText: "",
      tipsTextList: [
        {
          value: "夜幕下的赛博朋克城市",
        },
        {
          value: "美丽的花田",
        },
        {
          value: "中国古街的中秋明月",
        },
        {
          value: "下雨夜晚街道上的人",
        },
        {
          value: "宇宙中扭曲的时空和黑洞",
        },
        {
          value: "宇宙中扭曲洞",
        },
        {
          value: "宇宙曲洞",
        },
      ],
      selectImgUrl: "",
      imgList: [
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/57/96/22/1579622-eokchpmysu.png!YM0000",
        // },
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/57/91/69/1579169-xemygzdlbh.png!YM0000",
        // },
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/52/71/47/1527147-owdnaeagom.png!YM0000",
        // },
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/52/71/38/1527138-tekqxapuqg.png!YM0000",
        // },
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/52/71/47/1527147-owdnaeagom.png!YM0000",
        // },
        // {
        //   url:
        //     "https://hdimg01.shuxuehua.com/imgsr/1/52/71/38/1527138-tekqxapuqg.png!YM0000",
        // },
      ],
      swiperOption: {
        freeMode: true,
        spaceBetween: 10,
        slidesPerView: 4,
      },
      modeSelIndex: 0,
      whModeList: [
        // {
        //   modeName: "头像图",
        //   imgUrl: require("@/assets/img/AI/icon-1x1.png"),
        //   text: "1:1",
        // },
        // {
        //   modeName: "宽图相框",
        //   imgUrl: require("@/assets/img/AI/icon-5x3.png"),
        //   text: "5:3",
        // },
        // {
        //   modeName: "社交媒体",
        //   imgUrl: require("@/assets/img/AI/icon-3x4.png"),
        //   text: "3:4",
        // },
        // {
        //   modeName: "文章配图",
        //   imgUrl: require("@/assets/img/AI/icon-4x3.png"),
        //   text: "4:3",
        // },
        // {
        //   modeName: "电脑壁纸",
        //   imgUrl: require("@/assets/img/AI/icon-16x9.png"),
        //   text: "16:9",
        // },
        // {
        //   modeName: "手机壁纸",
        //   imgUrl: require("@/assets/img/AI/icon-9x16.png"),
        //   text: "9:16",
        // },
      ],
      isOpen: false,
      isClick: false,
    };
  },
  mounted() {
    findUserFuncInfo({
      userFuncType: 17,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isOpen = true;
          this.getDrawStyleList();
        }
      }
    });
  },
  methods: {
    closeCreatePop() {
      clearTimeout(timer);
      timer = null;
      this.isCreate = false;
      timerNum = 0;
    },
    getDrawStyleList() {
      getDrawStyleList({
        styleType: 31,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res.data);
          this.whModeList = res.data;
        }
      });
    },
    clearInputText() {
      this.inputText = "";
    },
    downloadImage() {
      if (!this.selectImgUrl) {
        return this.$notify({
          title: "提示",
          message: "请选择图片",
          type: "error",
          duration: 1000,
        });
      }
      window.open(this.selectImgUrl.split("!YM")[0], "_blank");
      return;
      html2canvas(document.getElementById(`bigImage`), {
        useCORS: true,
        width: 512,
        height: 512,
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/jpeg", 1.0);
        var a = document.createElement("a"); // 创建一个a节点插入的document
        var event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = `downloadImg.png`; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      });
      // let image = new Image();
      // image.setAttribute("crossOrigin", "Anonymous");
      // image.onload = function () {};
      // image.src = this.selectImgUrl;
      // console.log(image);
    },
    confrim() {
      if (!this.inputText) {
        return this.$notify({
          title: "提示",
          message: "请输入描述词",
          type: "error",
          duration: 2000,
        });
      }
      if (this.isClick) return;
      this.setClickStatus();
      createAIDrawWork({
        sizeDrawStyleId: this.whModeList[this.modeSelIndex].drawStyleId,
        inputPrompt: this.inputText,
      }).then((res) => {
        this.isClick = false;
        if (res.code == 1) {
          this.isCreate = true;
          this.singleDrawWork(res.data.drawWorkId);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    setClickStatus() {
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false;
      }, 1e4);
    },
    singleDrawWork(drawWorkId) {
      singleDrawWork({
        drawWorkId,
      }).then((res) => {
        if (res.code == 1) {
          clearTimeout(timer);
          timer = null;
          this.createStatus = res.data.workResultStatus;
          if (res.data.workResultStatus == 199) {
            this.$notify({
              title: "提示",
              message: res.data.workResultMsg,
              type: "error",
              duration: 2000,
            });
          } else if (res.data.workResultStatus == 200) {
            this.imgList.unshift({
              url: res.data.workImage,
            });
            this.selectImgUrl = res.data.workImage;
          } else {
            let timeInterval = 3;
            timerNum++;
            if (120 / (timerNum * timeInterval) <= 1) {
              this.createStatus = 199;
              timerNum = 0;
              return this.$notify({
                title: "提示",
                message: "生成超时，请稍后再试",
                type: "error",
                duration: 2000,
              });
            }
            timer = setTimeout(() => {
              this.singleDrawWork(drawWorkId);
            }, 3e3);
          }
        }
      });
    },
    addImg() {
      if (!this.selectImgUrl) {
        return this.$notify({
          title: "提示",
          message: "请选择图片",
          type: "error",
          duration: 1000,
        });
      }
      addImg({
        images: this.selectImgUrl,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify.success({
            title: "提示",
            message: "保存成功",
            icon: "success",
            duration: 2e3,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.AI-draw-container {
  padding: 20px;
  font-family: "思源黑体";
  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 44px;
    margin-bottom: 10px;
  }
  .main-box {
    display: flex;
    min-height: 490px;
    .left-box {
      min-width: 636px;
      max-width: 636px;
      margin-right: 12px;
      .input-box {
        max-width: 636px;
        padding: 20px;
        border-radius: 16px;
        background: rgba(255, 255, 255, 1);
        border: 2px solid rgba(232, 234, 236, 1);
        textarea {
          width: 100%;
          font-size: 18px;
          line-height: 1.5;
          height: 188px;
          border: 0;
          outline: none;
          resize: none;
        }
        .tips-box {
          display: flex;
          height: 32px;
          align-items: center;
          justify-content: space-between;
          border-bottom: 2px solid rgba(242, 242, 242, 1);
          & > p {
            font-size: 15px;
            color: rgba(59, 59, 59, 1);
            font-weight: 500;
          }
          .box-right {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 18px;
            color: rgba(59, 59, 59, 1);
            line-height: 32px;
            font-weight: 500;
            .clear-btn {
              display: flex;
              align-items: center;
              position: relative;
              padding-left: 12px;
              cursor: pointer;
              &:hover {
                color: rgba(51, 136, 255, 1);
                .el-icon-error {
                  color: rgba(51, 136, 255, 1);
                }
              }
              .el-icon-error {
                color: rgba(59, 59, 59, 0.5);
                font-size: 24px;
                margin-right: 5px;
              }
              &:after {
                width: 1px;
                height: 18px;
                content: "";
                background-color: rgba(49, 49, 50, 1);
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
              }
            }
            & > p {
              padding: 0 10px;
            }
          }
        }
        .tips-text-list {
          position: relative;
          padding-top: 20px;
          height: 90px;
          overflow: auto;
          .list {
            height: 100%;
            padding: 0 60px 0 0;
            overflow: auto;
            .tips-text {
              cursor: pointer;
              display: inline-block;
              border-radius: 40px;
              height: 30px;
              line-height: 30px;
              padding: 0 22px;
              font-size: 14px;
              color: rgba(59, 59, 59, 1);
              background-color: rgba(59, 59, 59, 0.08);
              margin: 0 20px 10px 0;
              &.select {
                background-color: rgba(51, 136, 255, 1);
                color: #fff;
              }
            }
          }
          .action-btn {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            color: rgba(59, 59, 59, 1);
            position: absolute;
            right: 0;
            bottom: 10px;
            cursor: pointer;
            display: flex;
            align-items: center;
            .el-icon-refresh-right {
              font-size: 18px;
              margin-right: 2px;
              font-weight: 500;
            }
            &:hover {
              color: rgba(51, 136, 255, 1);
              i {
                color: rgba(51, 136, 255, 1);
              }
            }
          }
        }
      }
      .whmode-list {
        display: flex;
        margin-top: 10px;
        .whmode-item {
          width: 94px;
          min-width: 94px;
          height: 100px;
          box-sizing: border-box;
          text-align: center;
          border-radius: 11px;
          background: rgba(245, 245, 245, 1);
          margin-right: 14px;
          cursor: pointer;
          position: relative;
          &:last-child {
            margin-right: 0;
          }
          &.select {
            &::before {
              position: absolute;
              display: block;
              content: "";
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              top: 0;
              left: 0;
              border: 2px solid rgba(51, 136, 255, 1);
              border-radius: 8px;
            }
          }
          .whmode-img {
            width: 32px;
            height: 32px;
            margin: 10px auto 6px;
          }
          .whmode-text {
            font-size: 18px;
            line-height: 20px;
            color: rgba(3, 6, 22, 1);
            margin-bottom: 2px;
          }
          .whmode-modename {
            font-size: 14px;
            line-height: 20px;
            color: rgba(146, 146, 146, 1);
          }
        }
      }
    }
    .img-box {
      width: 440px;
      .big-image-box {
        position: relative;
        width: 440px;
        height: 386px;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: 100%;
        }
        .icon-box {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 30px;
          height: 30px;
          border-radius: 4px;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            i {
              color: rgba(51, 136, 255, 1);
            }
          }
          i {
            font-size: 22px;
            color: #fff;
          }
        }
      }
      .img-list {
        .img-box {
          width: 96px;
          height: 96px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
            margin: 0;
          }
          &.select {
            &::before {
              position: absolute;
              display: block;
              content: "";
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              top: 0;
              left: 0;
              border: 2px solid rgba(51, 136, 255, 1);
              border-radius: 8px;
            }
          }
        }
      }

      img {
        border-radius: 8px;
        object-fit: cover;
        box-sizing: border-box;
      }
    }
    .action-box {
      width: 60px;
      height: 386px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 22px;
      .btn-box {
        cursor: pointer;
        text-align: center;
        margin-bottom: 24px;
        &:hover {
          .icon-box {
            i {
              color: rgba(51, 136, 255, 1);
            }
            border-color: rgba(51, 136, 255, 1);
          }
          p {
            color: rgba(51, 136, 255, 1);
          }
        }
        .icon-box {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          border: 2px solid rgba(0, 0, 0, 1);
          width: 48px;
          height: 48px;
          margin: 0 auto 4px;
          i {
            font-size: 20px;
            color: rgba(0, 0, 0, 1);
            font-weight: 600;
          }
        }
        p {
          font-size: 11px;
          line-height: 17px;
          font-weight: 600;
        }
      }
    }
  }
  .confirm-btn {
    display: block;
    width: 332px;
    height: 72px;
    border-radius: 40px;
    margin: 0 auto;
    background-color: rgba(51, 136, 255, 1);
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    margin-top: 69px;
    transform: translateX(-300px);
    &:hover {
      opacity: 0.9;
    }
  }
  .popup {
    &.preview {
      .popup-content {
        height: 80%;
        .popup-container {
          padding: 20px;
          height: calc(100% - 78px);
          .preview-img {
            height: 100%;
          }
        }
      }
    }
    &.create {
      .popup-content {
        width: 500px;
        .popup-container {
          text-align: center;
          padding-bottom: 20px;
          .status-box {
            height: 300px;
            font-size: 150px;
            display: flex;
            justify-content: center;
            align-items: center;
            .el-icon-loading {
              color: rgba(0, 0, 0, 0.5);
            }
            .el-icon-success {
              color: #67c23a;
            }
            .el-icon-error {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
